export const services = [
  {
    id: 1,
    title: "Supply Service",
    image: "/assets/img/service/service4.jpeg",
    description: "Our Supply Service ensures seamless procurement and delivery of high-quality materials, meeting your project needs with efficiency and reliability.",
    category: "Supply Chain",
    clients: "Various Industries",
    timeframe: "24/7 Availability",
    details: {
      mainImage: "/assets/img/service/service1.jpg",
      content: [
        "Our comprehensive supply service is designed to meet all your material needs with precision and efficiency. We source high-quality materials from trusted suppliers worldwide.",
        "With our extensive network and logistical expertise, we ensure timely delivery to keep your projects on schedule. Our team handles everything from procurement to transportation.",
        "We maintain strict quality control measures at every stage of the supply process to guarantee that all materials meet industry standards and your specific requirements."
      ],
      features: [
        "Global sourcing network with competitive pricing",
        "Just-in-time delivery options available",
        "Customized packaging and handling solutions",
        "Real-time tracking of shipments"
      ],
      secondaryImages: [
        "/assets/img/service/service1-2.jpg",
        "/assets/img/service/service1-3.jpg",
      ]
    }
  },
  {
    id: 2,
    title: "Heavy Equipment Supply",
    image: "/assets/img/service/service2.jpeg",
    description: "We provide reliable heavy equipment supply, ensuring your projects run smoothly with top-quality machinery and expert support.",
    category: "Construction Equipment",
    clients: "Construction Firms",
    timeframe: "Project-Based",
    details: {
      mainImage: "/assets/img/service/service2.jpg",
      content: [
        "Our heavy equipment supply service provides access to a wide range of machinery for construction, mining, and industrial applications. We offer both sales and rental options.",
        "From excavators and bulldozers to cranes and loaders, our inventory is maintained to the highest standards. Each piece of equipment undergoes rigorous inspection before deployment.",
        "Our expert team can help you select the right equipment for your specific project requirements, considering factors like terrain, project duration, and budget constraints."
      ],
      features: [
        "Extensive fleet of well-maintained equipment",
        "Operator training and technical support",
        "Flexible rental terms and purchase options",
        "On-site equipment maintenance available"
      ],
      secondaryImages: [
        "/assets/img/service/service2-1.jpg",
        "/assets/img/service/service2-2.jpg",
      ]
    }
  },
  {
    id: 3,
    title: "City Works",
    image: "/assets/img/service/service3.webp",
    description: "Our City Works services support urban development with reliable infrastructure solutions, ensuring efficiency and sustainability in every project.",
    category: "Urban Infrastructure",
    clients: "Municipalities",
    timeframe: "Long-Term Contracts",
    details: {
      mainImage: "/assets/img/service/service3.jpg",
      content: [
        "Our City Works division specializes in urban infrastructure development and maintenance. We partner with municipalities to create sustainable, efficient city spaces.",
        "From road construction and repair to public space development and utility infrastructure, our team brings expertise in all aspects of urban development.",
        "We employ innovative techniques and materials to ensure our projects not only meet current needs but are built to last for future generations."
      ],
      features: [
        "Comprehensive urban planning services",
        "Green infrastructure solutions",
        "Traffic management systems",
        "Public space design and development"
      ],
      secondaryImages: [
        "/assets/img/service/service3-1.jpg",
        "/assets/img/service/service3-2.jpg"
      ]
    }
  },
  {
    id: 4,
    title: "Personel Supply",
    image: "/assets/img/service/service1.png",
    description: "We provide skilled and reliable personnel to meet your project's demands, ensuring efficiency and excellence in every task.",
    category: "Human Resources",
    clients: "Various Industries",
    timeframe: "Flexible Arrangements",
    details: {
      mainImage: "/assets/img/service/service4.jpg",
      content: [
        "Our personnel supply service connects you with skilled professionals across various industries. We carefully vet all candidates to ensure they meet your specific requirements.",
        "Whether you need temporary staff for a short-term project or permanent placements, we can provide solutions tailored to your needs. Our database includes professionals at all skill levels.",
        "We handle all aspects of the employment process, from recruitment and screening to payroll management, allowing you to focus on your core business activities."
      ],
      features: [
        "Extensive network of qualified professionals",
        "Industry-specific recruitment specialists",
        "Comprehensive background checks",
        "Flexible staffing solutions"
      ],
      secondaryImages: [
        "/assets/img/service/service4-1.jpg",
        "/assets/img/service/service4-2.jpg",
      ]
    }
  },
  {
    id: 5,
    title: "Construction",
    image: "/assets/img/service/service5.jpg",
    description: "We build with precision, strengthen with quality, and deliver excellence in every project.",
    category: "Building Construction",
    clients: "Private & Public Sector",
    timeframe: "Project-Based",
    details: {
      mainImage: "/assets/img/service/service5-1.jpg",
      content: [
        "Our construction services cover all aspects of building projects, from initial design to final completion. We specialize in both residential and commercial construction.",
        "With a focus on quality craftsmanship and attention to detail, we deliver structures that are not only beautiful but built to last. Our projects consistently meet or exceed industry standards.",
        "We utilize the latest construction technologies and sustainable building practices to create efficient, environmentally friendly structures that stand the test of time."
      ],
      features: [
        "Full-service design-build capability",
        "Sustainable construction practices",
        "Quality assurance at every stage",
        "Project management expertise"
      ],
      secondaryImages: [
        "/assets/img/service/service5-2.jpg",
        "/assets/img/service/service5-4.jpg",
        "/assets/img/service/service5-3.jpg",
      ]
    }
  }
];